import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Toast } from './toast';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private toastSubject = new Subject<Toast>();

  constructor() { }

  pushNewToast(toast: Toast) {
    this.toastSubject.next(toast);
  }

  getNewToast() {
    return this.toastSubject.asObservable();
  }
}
